var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon3(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 63,
    viewBox: "0 0 57 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    "data-name": "Rectangle 1668",
    width: 57,
    height: 63,
    transform: "translate(0 0)",
    fill: "#ff9ee0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680",
    transform: "translate(4 3.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665",
    transform: "translate(-4 -3.008)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14064",
    "data-name": "Path 14064",
    d: "M41.526,18.306a6.387,6.387,0,0,0-3.669,1.153,6.42,6.42,0,0,0-9.178-3.182V6.423a6.423,6.423,0,1,0-12.846,0V29.639l-2.284-3.957a6.423,6.423,0,0,0-11.16,6.362C10.146,48.4,15.3,55.239,27.074,55.239A20.9,20.9,0,0,0,47.949,34.364V24.729a6.43,6.43,0,0,0-6.423-6.423m3.212,16.058A17.684,17.684,0,0,1,27.074,52.027c-9.262,0-13.746-4.4-21.809-21.414-.019-.04-.039-.078-.061-.116a3.214,3.214,0,0,1,2.776-4.821,3.231,3.231,0,0,1,.837.111,3.192,3.192,0,0,1,1.951,1.5l5.281,9.148a1.606,1.606,0,0,0,3-.8V6.423a3.212,3.212,0,1,1,6.423,0V22.8a1.606,1.606,0,0,0,3.212,0v-.963a3.212,3.212,0,1,1,6.423,0v2.89a1.606,1.606,0,0,0,3.212,0,3.212,3.212,0,1,1,6.423,0Z",
    transform: "translate(5.1 4.627)",
    fill: "#ff9ee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14065",
    "data-name": "Path 14065",
    d: "M5.146,14.491h0A1.206,1.206,0,0,0,6,12.43L4.114,10.547H11.34a1.205,1.205,0,1,0,0-2.411H4.114L5.991,6.261A1.2,1.2,0,0,0,6.355,5.4a1.188,1.188,0,0,0-.347-.844,1.2,1.2,0,0,0-1.714-.008L.355,8.486a1.141,1.141,0,0,0-.268.409,1.185,1.185,0,0,0,0,.885,1.131,1.131,0,0,0,.268.416L4.29,14.133a1.192,1.192,0,0,0,.855.359",
    transform: "translate(3.078 1.781)",
    fill: "#ff9ee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14066",
    "data-name": "Path 14066",
    d: "M94.1,10.547h7.225l-1.877,1.875a1.2,1.2,0,0,0-.364.861,1.206,1.206,0,0,0,2.062.853l3.939-3.939a1.142,1.142,0,0,0,.267-.408,1.189,1.189,0,0,0,0-.887,1.139,1.139,0,0,0-.268-.414L101.152,4.55a1.206,1.206,0,1,0-1.709,1.7l1.885,1.883H94.1a1.205,1.205,0,1,0,0,2.411",
    transform: "translate(-53.827 1.781)",
    fill: "#ff9ee0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon3);
export default __webpack_public_path__ + "static/media/media_icon3.8bc9dc8f6256d63e8448dc3a7bd07466.svg";
export { ForwardRef as ReactComponent };